var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlus = function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 10a8.333 8.333 0 1 0 16.666 0 8.333 8.333 0 0 0-16.666 0Zm15.151 0a6.818 6.818 0 1 1-13.636 0 6.818 6.818 0 0 1 13.636 0Zm-7.576.758v3.03h1.516v-3.03h3.03V9.242h-3.03v-3.03H9.242v3.03h-3.03v1.516h3.03Z",
    fill: "#669AEC"
  })));
};
export default SvgIconPlus;